import { render, staticRenderFns } from "./CourseMenuAmountForm.vue?vue&type=template&id=50adfd17&scoped=true"
import script from "./CourseMenuAmountForm.vue?vue&type=script&lang=js"
export * from "./CourseMenuAmountForm.vue?vue&type=script&lang=js"
import style0 from "./CourseMenuAmountForm.vue?vue&type=style&index=0&id=50adfd17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50adfd17",
  null
  
)

export default component.exports